/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export class VendorListModel {
  uuid: string | undefined = undefined;
  owner: string | undefined = undefined;
  businessProfileUuid: string | undefined = undefined;
  serviceProviderUuid: string | undefined = undefined;
  name: string| null = null;
  industryType: string | undefined = undefined;
  uniqueIdNumber: string | undefined = undefined;
  mainPhoneNumber: string | undefined = undefined;
  country: string | null = null;
  tags: string | undefined = undefined; // tags string separated by ', '
  legalEntityUuid: string | null = null;
  platformMember: boolean | undefined = undefined;
  mainEmailAddress: string | undefined = undefined;
  hasContacts = false; //frontend only
  paymentTimeLimit: string | undefined = undefined;
  isBlocked = false;
}
